/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ObservationOverview } from "./ObservationOverview";
import {
  ObservationOverviewFromJSON,
  ObservationOverviewFromJSONTyped,
  ObservationOverviewToJSON,
  ObservationOverviewToJSONTyped,
} from "./ObservationOverview";

/**
 *
 * @export
 * @interface GLDOverview
 */
export interface GLDOverview {
  /**
   *
   * @type {string}
   * @memberof GLDOverview
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof GLDOverview
   */
  broId: string;
  /**
   *
   * @type {object}
   * @memberof GLDOverview
   */
  linkedGmns?: object;
  /**
   *
   * @type {string}
   * @memberof GLDOverview
   */
  gmwBroId?: string | null;
  /**
   *
   * @type {string}
   * @memberof GLDOverview
   */
  tubeNumber?: string | null;
  /**
   *
   * @type {Date}
   * @memberof GLDOverview
   */
  researchFirstDate?: Date | null;
  /**
   *
   * @type {Date}
   * @memberof GLDOverview
   */
  researchLastDate?: Date | null;
  /**
   *
   * @type {string}
   * @memberof GLDOverview
   */
  qualityRegime?: string | null;
  /**
   *
   * @type {Array<ObservationOverview>}
   * @memberof GLDOverview
   */
  readonly observations?: Array<ObservationOverview>;
}

/**
 * Check if a given object implements the GLDOverview interface.
 */
export function instanceOfGLDOverview(value: object): value is GLDOverview {
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  return true;
}

export function GLDOverviewFromJSON(json: any): GLDOverview {
  return GLDOverviewFromJSONTyped(json, false);
}

export function GLDOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): GLDOverview {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    broId: json["bro_id"],
    linkedGmns: json["linked_gmns"] == null ? undefined : json["linked_gmns"],
    gmwBroId:
      json["gmw_bro_id"] === undefined
        ? undefined
        : json["gmw_bro_id"] === null
        ? null
        : json["gmw_bro_id"],
    tubeNumber:
      json["tube_number"] === undefined
        ? undefined
        : json["tube_number"] === null
        ? null
        : json["tube_number"],
    researchFirstDate:
      json["research_first_date"] === undefined
        ? undefined
        : json["research_first_date"] === null
        ? null
        : new Date(json["research_first_date"]),
    researchLastDate:
      json["research_last_date"] === undefined
        ? undefined
        : json["research_last_date"] === null
        ? null
        : new Date(json["research_last_date"]),
    qualityRegime:
      json["quality_regime"] === undefined
        ? undefined
        : json["quality_regime"] === null
        ? null
        : json["quality_regime"],
    observations:
      json["observations"] == null
        ? undefined
        : (json["observations"] as Array<any>).map(ObservationOverviewFromJSON),
  };
}

export function GLDOverviewToJSON(json: any): GLDOverview {
  return GLDOverviewToJSONTyped(json, false);
}

export function GLDOverviewToJSONTyped(
  value?: Omit<GLDOverview, "uuid" | "observations"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_id: value["broId"],
    linked_gmns: value["linkedGmns"],
    gmw_bro_id: value["gmwBroId"],
    tube_number: value["tubeNumber"],
    research_first_date:
      value["researchFirstDate"] == null
        ? value["researchFirstDate"]
        : value["researchFirstDate"].toISOString().substring(0, 10),
    research_last_date:
      value["researchLastDate"] == null
        ? value["researchLastDate"]
        : value["researchLastDate"].toISOString().substring(0, 10),
    quality_regime: value["qualityRegime"],
  };
}
